import LanguagePack from "../../../../../shared/lib/html5-software-library/src/ranj/language/LanguagePack";
import Anchor from "../../../../../shared/lib/html5-software-library/src/ranj/layout/Anchor";
import AbstractCollaborationScreenMediator from "../core/view/AbstractCollaborationScreenMediator";
import Scenario from "../ngt/scenario/Scenario";
import ScenarioLibrary from "../ngt/scenario/ScenarioLibrary";
import ScenarioCommandEvent from "../ngt/scenario/controller/ScenarioCommandEvent";

export default class EpisodeSelectionScreenMediator extends AbstractCollaborationScreenMediator {

    /**
     * @param {createjs.DisplayObject} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LanguagePack} languagePack 
     * @param {*} layoutManager 
     * @param {*} soundManager 
     * @param {*} gameAssets  
     * @param {ScenarioLibrary} scenarioLibrary
     */
    constructor(target, dispatcher, languagePack, layoutManager, soundManager, gameAssets, scenarioLibrary) {
        super(target, dispatcher, languagePack, layoutManager, soundManager, gameAssets);

        this._scenarioLibrary = scenarioLibrary;
    }

    initialize() {
        super.initialize();

        this._target.titleTextfield.text = this.getText("episodeSelection.title");

        this.anchorObject(this._target.titleTextfield, Anchor.T);

        this._initializeEpisodeButtons();
    }

    _initializeEpisodeButtons() {
        const templateButton = this._target.episodeButton;
        const buttonSkin = this._gameAssets.AssetsButtonsDialogButton;
        const container = templateButton.parent;
        const scenarios = this._scenarioLibrary.getScenarios();
        const ySpacing = templateButton.getBounds().height + 20;
        let yOffset = 0;

        for (const scenario of scenarios) {
            const button = new buttonSkin();
            container.addChild(button);
            button.x = templateButton.x;
            button.y = templateButton.y + yOffset;
            const clickHandler = () => this._onScenarioPressed(scenario);
            const label = this.getText(scenario.name);
            this.createSlice9Button(button, clickHandler, label);

            yOffset += ySpacing;
        }

        templateButton.visible = false;
    }

    /**
     * 
     * @param {Scenario} scenario 
     */
    _onScenarioPressed(scenario) {
        console.log(`[EpisodeSelectionScreenMediator] Play scenario id ${scenario.id}`);
        this.dispatch(ScenarioCommandEvent.PLAY_SCENARIO, { scenarioId: scenario.id });
    }
}
